<template>
  <b-modal
      :id="idModal"
      :title="clienteToken.id ? 'Atualizar Cliente Token' : 'Novo Cliente Token'"
      size="md"
      hide-footer
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @close="onResetModel"
      @cancel="onResetModel"
  >
    <validation-observer ref="refFormCadastroClienteDKPToken">
      <b-form @reset="onResetModel">
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="Cliente"
                label-for="nome"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Cliente"
                  rules="required"
              >
                <b-form-select
                    id="dkp_client_id"
                    v-model="clienteToken.dkp_client_id"
                    :state="errors.length > 0 ? false:null"
                    label-field="text"
                    value-field="value"
                    :options="$store.getters['sisDkpClientesTokens/GET_OPTIONS_CLIENTES']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="Data de Validade"
                label-for="data_validade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Data de Validade"
                  rules="required"
              >
                <b-form-input
                    id="data_validade"
                    v-mask="'##/##/####'"
                    v-model="clienteToken.data_validade"
                    :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" class="row justify-content-end px-0">
            <b-button
                variant="primary"
                @click="addClienteDkp"
            >
              {{ clienteToken.id ? 'Atualizar' : 'Cadastrar' }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';

export default {
  props: {
    idModal: {
      type: String,
      default: 'modal-add',
    },
  },
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    clienteToken: {
      get() {
        return this.$store.getters['sisDkpClientesTokens/GET_DKP_CLIENTE_TOKEN'];
      },
      set(val) {
        this.$store.commit('sisDkpClientesTokens/SET_DKP_CLIENTE_TOKEN', val);
      },
    },
  },
  methods: {
    addClienteDkp() {
      this.$refs.refFormCadastroClienteDKPToken.validate()
        .then((success) => {
          if (success) {
            this.$bvModal.hide(this.idModal);
            this.$emit('add-clienteToken-dkp-token', this.clienteToken);
          }
        });
    },
    onResetModel() {
      this.$refs.refFormCadastroClienteDKPToken.reset();
      this.$store.dispatch('sisDkpClientesTokens/RESERT_DKP_CLIENTE_TOKEN');
    },
  },
};
</script>

<style scoped lang="scss">

</style>
